import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import 'lib-flexible'
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css
// import 'swiper/swiper-bundle.css'
import 'swiper/css';

const app = createApp(App)
app.use(ElementPlus)
app.use(router)
app.use(vue3videoPlay)
app.mount('#app')
